(function (app, ng) {

    app.config(["$stateProvider", function ($stateProvider) {
        $stateProvider.state("Transaction.Determine.Documents",
            {
                url: "/Documents",
                component: "determineDocuments",
                resolve: {
                    determineDocuments: ["transactionDocumentApi", "$stateParams", function (transactionDocumentApi, $stateParams) {
                        return transactionDocumentApi.getTransactionDocumentsByType($stateParams.transactionId, "DetermineDocument");
                    }],
                    additionalDocuments: ["transactionDocumentApi", "$stateParams", function (transactionDocumentApi, $stateParams) {
                        return transactionDocumentApi.getTransactionDocumentsByType($stateParams.transactionId, "AdditionalDocument");
                    }],
                    inforce: ["transaction", "inforceTransactionApi", function (transaction, inforceTransactionApi) {
                        return inforceTransactionApi.get(transaction.Id).catch(ng.noop);
                    }],
                    nextStage: ["transaction", "_", "productApi", "inforce", function (transaction, _, productApi, inforce) {
                        if (inforce)
                            return "Transaction.Application.InforceApplication";
                        //return "Transaction.Application.FormsPipeline";
                        else if (transaction.Product) {
                            return productApi.getProduct(transaction.Product.Id)
                                .then(function(prod) {
                                    if (prod.Plugins.includes("FireLight"))
                                        return "Transaction.Application.Prefill";
                                    else
                                        return "Transaction.Application.FormsPipeline";
                                });
                        } else
                            return "NoSuitableProduct";
                    }],
                    prevStage: ["inforce", function (inforce) {
                        return inforce ? "Transaction.Determine.Inforce" : "Transaction.Determine.ProductShelf";
                    }]
                },
                onEnter: ["transaction", "transactionApi", function (transaction, transactionApi) {
                    transaction.LastTransactionStage = "Documents";
                    transactionApi.updateLastTransactionStage(transaction.Id, transaction);
                }]
            });
    }]);

    app.component("determineDocuments",
        {
            templateUrl: "/App/Transaction/Determine/Documents/template.html",
            controller: determineDocumentsController,
            bindings: {
                transaction: "<",
                transactionGroup: "<",
                determineDocuments: "<",
                additionalDocuments: "<",
                inforce: "<",
                nextStage: "<",
                prevStage: "<"
            }
        });

    determineDocumentsController.$inject = ["$state", "$scope", "_", "$q", "$mdDialog", "transactionApi", "transactionDocumentApi", "productApi"];
    function determineDocumentsController($state, $scope, _, $q, $mdDialog, transactionApi, transactionDocumentApi, productApi) {
        $scope.$parent.$ctrl.getCurrentStage($state);
        var $ctrl = this;
        ng.extend($ctrl,
            {
                ui: {
                    Saving: []
                },
                addedDetermineDocuments: [],
                uploadRequiredDocument: uploadRequiredDocument,
                uploadAdditionalDocuments: uploadAdditionalDocuments,
                removeDocument: removeDocument,
                next: next,
                submitApp: submitApp
            });

        function updateStatus(status) {
            $ctrl.transaction.TransactionStatus = status;
            return transactionApi.updateTransactionStatus($ctrl.transaction.Id, $ctrl.transaction).then(function () {
                $ctrl.ui.generating = false;
                $state.go("Home.ViewTransactions");
            });
        }

        function submitApp($event) {
            var leave = $mdDialog.confirm({
                title: "Are you sure you would like to submit this application?",
                htmlContent: "<p>If you choose to continue, your transaction will be compiled and submitted for review.</p> <p> Any edits to this transaction in the future will be unavailable.</p>",
                targetEvent: $event,
                ariaLabel: "Confirm submitting transaction",
                ok: "Submit",
                cancel: "Cancel",
                skipHide: true,
                clickOutsideToClose: false
            });
            $mdDialog.show(leave)
                .then(function () {
                    $ctrl.ui.generating = true;
                    updateStatus("NoSuitableProduct");
                });
        }

        function uploadRequiredDocument(file, index, requiredDocumentName) {
            if (file !== null) {
                $ctrl.ui.Saving[index] = true;
                var payload = new FormData();

                if ($ctrl.sortedDetermineDocuments[index]) {
                    payload.append("updateTransactionDocument", file, file.name);
                    transactionDocumentApi
                        .updateTransactionDocument($ctrl.transaction.Id,
                        $ctrl.sortedDetermineDocuments[index].Id,
                        payload).then(function (response) {
                            $ctrl.sortedDetermineDocuments[index] = response;
                            $ctrl.ui.Saving[index] = false;
                        });
                } else {
                    payload.append("transactionDocument", file, file.name);
                    transactionDocumentApi
                        .addTransactionDocument($ctrl.transaction.Id,
                        "DetermineDocument",
                        requiredDocumentName,
                        payload).then(function (response) {
                            $ctrl.sortedDetermineDocuments[index] = response;
                            $ctrl.ui.Saving[index] = false;
                        });
                }

            } else return $ctrl.sortedDetermineDocuments[index];
        };

        function uploadAdditionalDocuments(files) {
            $ctrl.ui.UploadingAdditionalDocuments = true;
            var promises = [];

            ng.forEach(files,
                function (file) {
                    var payload = new FormData();
                    payload.append("additionalDocument", file, file.name);

                    promises.push(transactionDocumentApi
                        .addAdditionalDocument($ctrl.transaction.Id, payload, "AdditionalDocument")
                        .then(function (response) {
                            $ctrl.additionalDocuments.push(response);
                        }));
                });

            $q.all(promises).then(function () {
                $ctrl.ui.UploadingAdditionalDocuments = false;
            });
        };

        function removeDocument(document, index, $event) {
            var confirm = $mdDialog.confirm({
                title: "Are you sure you want to delete this document?",
                targetEvent: $event,
                ariaLabel: "Delete additional document",
                ok: "Yes",
                cancel: "No",
                skipHide: true,
                clickOutsideToClose: false
            });
            $mdDialog.show(confirm).then(function () {
                $ctrl.additionalDocuments.splice(index, 1);

                transactionDocumentApi.deleteDocument($ctrl.transaction.Id, document.Id);
            });
        };

        function removeExtension(fileName) {
            fileName = fileName.replace(/\.[^/.]+$/, "");
            return fileName;
        }

        function next() {
            $state.go($ctrl.nextStage, { transactionId: $ctrl.transaction.Id });
        }

        this.$onInit = function() {
            $ctrl.sortedDetermineDocuments = [];

            var index = 0;
            ng.forEach($ctrl.transaction.RequiredDetermineDocuments,
                function (fileName) {
                    var doc = _.find($ctrl.determineDocuments,
                        function (d) {
                            return d.RequiredFileName === fileName.Value
                                && !_.find($ctrl.sortedDetermineDocuments, function(s) {
                                    return s.FileName === d.FileName;
                                });
                        });

                    if (doc) $ctrl.sortedDetermineDocuments[index] = doc;
                    index++;
                });
            console.log($ctrl.sortedDetermineDocuments);
            if ($ctrl.inforce) {
                if ($ctrl.inforce.ProductName) {
                    $ctrl.productName = $ctrl.inforce.ProductName;
                    $ctrl.businessName = $ctrl.inforce.CarrierName;
                } else {
                    productApi.getProduct($ctrl.inforce.ProductId)
                        .then(function (product) {
                            $ctrl.productName = product.Name;
                            $ctrl.businessName = product.Carrier.Business.Name;
                        });

                }
            } else if ($ctrl.transaction.Product) {
                $ctrl.productName = $ctrl.transaction.Product.Name;
                $ctrl.businessName = $ctrl.transaction.Product.Carrier.Business.Name;
            }

            $ctrl.addedDetermineDocuments = _.clone($ctrl.sortedDetermineDocuments);
        };
    }

})(window.app, window.angular);